<template>
  <child/>
</template>

<script>
export default {
  name: 'EmptyLayout'
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/layouts/empty.vue